// Merge function
export const mergeJSONObjects = (obj1, obj2) => {
    return { ...obj1, ...obj2 };
  };